import React from 'react'
import {Header} from './components'
import Modals from './Modals'
import {ReferralsProvider} from './context/Referrals.context'

function ReferralTab({ patient, reachedBottom, setReachedBottom }) {
  return (
    <ReferralsProvider>
        <Header
          patient={patient}
          reachedBottom={reachedBottom}
          setReachedBottom={setReachedBottom}
        />
        <Modals patient={patient} />
    </ReferralsProvider>
  )
}

export default ReferralTab
